module.exports = __webpack_public_path__ + "img/classroom-header.34f35468.svg";